import { Select as BaseSelect } from '@base-ui-components/react/select'
import { cn } from '../../utils/cn'

export function SelectPopup({ className, ...props }: SelectPopup.Props) {
  return (
    <BaseSelect.Popup
      className={cn(
        // Base
        'group/select-popup overflow-y-auto rounded-lg bg-[canvas] py-1 text-gray-900 shadow-sm ring ring-inset ring-gray-200 [max-height:var(--available-height)]',
        // Focus
        'focus-visible:outline-none',
        // Transition
        'origin-[var(--transform-origin)] transition-[transform,scale,opacity] data-[ending-style]:scale-90 data-[side=none]:data-[ending-style]:scale-100 data-[side=none]:data-[starting-style]:scale-100 data-[starting-style]:scale-90 data-[ending-style]:opacity-0 data-[side=none]:data-[ending-style]:opacity-100 data-[side=none]:data-[starting-style]:opacity-100 data-[starting-style]:opacity-0 data-[side=none]:data-[ending-style]:transition-none data-[side=none]:data-[starting-style]:transition-none',
        className
      )}
      {...props}
    />
  )
}

export namespace SelectPopup {
  export interface Props extends BaseSelect.Popup.Props {}
}
